export default __webpack_public_path__ + "static/media/south_africa_icon.a8733524.png";